import { useQuery } from '@tanstack/react-query';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { getAllUsers } from '../services/users';
import { UserCard } from '../components/users/UserCard';
import { MemberListSkeleton } from '../components/LoadingSkeleton';

export function MembersPage() {
  const { isAuthenticated } = useAuth();

  const { data: users, isLoading, isError, error } = useQuery({
    queryKey: ['users'],
    queryFn: getAllUsers,
  });

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isLoading) {
    return (
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Medlemmer</h1>
        <MemberListSkeleton />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Medlemmer</h1>
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-600">
            Kunne ikke indlæse medlemmer: {error?.message || 'Ukendt fejl'}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Medlemmer</h1>

      {users && users.length > 0 ? (
        <div className="space-y-1">
          {/* Column headers */}
          <div className="hidden sm:flex items-center gap-4 px-4 pb-1 text-xs font-semibold text-gray-400 uppercase tracking-wide">
            <div className="w-12 flex-shrink-0" />
            <div className="flex-1">Navn</div>
            <div className="w-40">Telefon</div>
            <div className="w-48 hidden md:block">Email</div>
          </div>
          {users.map((user) => (
            <UserCard key={user.id} user={user} />
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <p className="text-gray-600">Ingen medlemmer fundet</p>
        </div>
      )}
    </div>
  );
}
